import React, { useMemo } from 'react';

import { TeamsNavigationProvider } from '@atlaskit/teams-app-internal-navigation/teams-navigation-provider';
import { useGlobalObjectPreviewPanels } from '@atlassian/preview-panel-global-objects/global-object-preview-panels';

import { useAggRelayEnvironmentProvider } from '@townsquare/relay-utils/agg-environment-provider';
import { useGeneratePath } from '@townsquare/router/primitives/path';
import { useRouter } from '@townsquare/router/useRouter';
import { teamsAppForYouRoute } from '@townsquare/routes/teams-app-for-you-view';
import { fg } from '@townsquare/stat-sig/gate';

export const TeamsNavigationProviderWrapper = ({
	cloudId,
	children,
}: {
	cloudId: string;
	children: React.ReactNode;
}):
	| string
	| number
	| boolean
	| React.JSX.Element
	| Iterable<React.ReactNode>
	| null
	| undefined => {
	const [, routerActions] = useRouter();

	const aggEnvironmentProvider = useAggRelayEnvironmentProvider();
	const { openPreviewPanel } = useGlobalObjectPreviewPanels('teams', cloudId, {
		environmentProvider: aggEnvironmentProvider,
	});
	const peopleDirectoryPath = useGeneratePath(teamsAppForYouRoute);

	const value = useMemo(
		() => ({
			navigate: routerActions.push,
			openPreviewPanel,
			contextEntryPoint: peopleDirectoryPath,
		}),
		[routerActions.push, openPreviewPanel, peopleDirectoryPath],
	);

	return fg('enable_team_preview_panel_entry_points') ? (
		<TeamsNavigationProvider value={value}>{children}</TeamsNavigationProvider>
	) : (
		children
	);
};
